function recurseObject(a) {
  var b = typeof a;
  if ('string' == b || 'number' == b || 'function' == b || 'boolean' == b) return a;
  if (null === a || void 0 === a) return a;

  if (Array.isArray(a)) {
    var _b = [];

    for (var c = 0; c < a.length; c++) {
      _b.push(recurseObject(a[c]));
    }

    return _b;
  }

  if ('object' == typeof a) {
    var _b2 = {};

    for (var _c in a) {
      var d = _c.toLowerCase();

      if ('data' === d) {
        _b2[d] = a[_c] && a[_c]._dataStore ? a[_c] : recurseObject(a[_c]);
        continue;
      }

      _b2[d] = recurseObject(a[_c]);
    }

    return _b2;
  }
}

function ignoreCaseExt(a) {
  a.addEventListener('beforedataupdate', function (a, b) {
    b.data = recurseObject(b.data);
  });
}

export default {
  extension: ignoreCaseExt,
  name: 'IgnoreCaseExt',
  type: 'extension',
  requiresFusionCharts: !0
};